// @ts-nocheck
import React, { useState } from 'react';
import ActionBar from '../../layout/ActionBar';
import AddUserGroup from './slideout/AddUserGroup';
import UserProfileGroupList from './components/UserProfileGroupList';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';

function UserProfileGroups() {
  const [pageTitle, setPageTitle] = usePageTitle([
    'User profile groups',
    'Settings',
  ]);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();

  const [addSlideoutOpen, setAddSlideoutOpen] = useState(false);
  const handleAddUserProfileGroup = (e) => {
    e.cancelBubble = true;
    setAddSlideoutOpen(true);
    return false;
  };

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={handleAddUserProfileGroup}
          text={t('Add group')}
          testId="add-user-group-button"
        />
      </ActionBar>

      <UserProfileGroupList reload={reload} />

      <SlidingPane
        isOpen={addSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setAddSlideoutOpen(false)}
      >
        <AddUserGroup
          cancel={() => setAddSlideoutOpen(false)}
          done={(d) => {
            setAddSlideoutOpen(false);
            setReload(new Date());
          }}
        />
      </SlidingPane>
    </>
  );
}

export default UserProfileGroups;
